import React, { useState } from 'react';
import DownloadProfile from '../Widgets/DownloadProfile';

import Notes from '../Widgets/Notes';
import ResearchDoctorates from '../Widgets/ResearchActivityDesignation/ResearchDoctorates';
import ResearchSpending from '../Widgets/ResearchActivityDesignation/ResearchSpending';
import PanelTitle from './PanelTitle';
import Panel from './Panel';
import MethodologySimilarLinks from '../Widgets/MethodologySimilarLinks';

export default function ResearchActivityDesignation(props) {
    const institutionData = props.institutionData;

    return (
        <Panel className="research-activity-designation">
            <div className="row">
                <div className="col-xs-12 col-sm-9">
                    <PanelTitle>Research Activity Designation</PanelTitle>
                </div>
                <div className="col-xs-12 col-sm-3">
                    <DownloadProfile institutionData={institutionData} />
                </div>
            </div>
            <div className="row my-4">
                <div className="col-xs-12 ">
                    <div className='p-4 emphasisBox'>
                        <div className="">
                            <div className='row'>
                                <div className="col-xs-12 col-sm-9">
                                    <div>
                                        <strong>Research Activity Designation:</strong><br />
                                        {institutionData.post_meta.research2025.label}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <MethodologySimilarLinks
                                        methodologyLink={'/carnegie-classification/research-designations/'}
                                        similarLink={`/institutions/?research2025[]=${institutionData.post_meta.research2025.value}`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6 mb-4">
                    {/* Research Doctorates Widget */}
                    <ResearchDoctorates institutionData={institutionData} />
                </div>

                <div className="col-lg-6 mb-4">
                    {/* Research Spending Widget */}
                    <ResearchSpending institutionData={institutionData} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mb-4">
                    <Notes field="research-tab-notes" institutionData={institutionData} />
                </div>
            </div>
        </Panel>
    );
}